// extracted by mini-css-extract-plugin
module.exports = {"content":"AuthorizeToLogin_content__2xumJ","sendOtp":"AuthorizeToLogin_sendOtp__1PTUT"};